export default "__VITE_ASSET__CVpWuoRH__"